import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const shiftScheduleService = {
  getAll: async () => {
    return await axios.get(`${domain}/api/ShiftSchedule`, { headers });
  },
  
  getById: async (id) => {
    return await axios.get(`${domain}/api/ShiftSchedule/${id}`, { headers });
  },

  create: async (payload) => {
    return await axios.post(`${domain}/api/ShiftSchedule`, payload, { headers });
  },

  update: async (id, payload) => {
    return await axios.put(`${domain}/api/ShiftSchedule/${id}`, payload, { headers });
  },

  delete: async (id) => {
    return await axios.delete(`${domain}/api/ShiftSchedule/${id}`, { headers });
  },


};

export default shiftScheduleService;